export const selectPaymentToken = state => state.payment.token;
export const selectPaymentMethodInfo = state => state.payment.info;
